import * as React from 'react';

import { IconReceiptPrinter } from '@lightspeed/flame/Icon/ReceiptPrinter';

import { DeviceIconWrapper } from '../../device.styles';
import { getPrinterStaticImage, getPrinterStaticImagePath } from './utils';

interface Props {
  model?: string;
  connected?: boolean;
  size?: string;
  Icon?: React.FC<any>;
}

const PrinterImage: React.FC<Props> = ({
  model = '',
  connected = false,
  size = '60px',
  Icon = IconReceiptPrinter,
}) => {
  const [isPrinterImageAvailable, setIsPrinterImageAvailable] = React.useState<boolean>(true);
  const [printerImage, setPrinterImage] = React.useState<string | undefined>();

  React.useEffect(() => {
    if (!model) return;
    setIsPrinterImageAvailable(true);
    setPrinterImage(getPrinterStaticImage(model));
  }, [model]);

  return isPrinterImageAvailable && connected ? (
    <img
      src={getPrinterStaticImagePath({ image: printerImage })}
      srcSet={getPrinterStaticImagePath({ image: printerImage, srcSetScale: '2x' })}
      alt={model}
      onError={() => {
        setIsPrinterImageAvailable(false);
      }}
      width={size}
      height={size}
    />
  ) : (
    <DeviceIconWrapper>
      <Icon size="32px" color={connected ? 'black' : 'gray-300'} />
    </DeviceIconWrapper>
  );
};

export { PrinterImage };
